import React from "react"
import logo from "../../../assets/img/logo/logo_secondary.png"
import "../../../assets/scss/components/app-loader.scss"
class SpinnerComponent extends React.Component {
  render() {
    return (
      <div className="fallback-spinner vh-100">
        <img className="fallback-logo" src={logo} alt="logo" style={{ width: 100, height: "auto" }} />
      </div>
    )
  }
}

export default SpinnerComponent
